// extracted by mini-css-extract-plugin
module.exports = {"container":"general_container__2tBMr","visuallyHidden":"general_visuallyHidden__1s89a"};